import React from 'react'
import ReactDOM from 'react-dom'

import './style/css/components/bootstrap.min.css'
import './style/css/components/bootstrap.min.css'
import './style/css/components/flickty.css'
import './style/css/components/index.css'
import './style/css/components/box.css'
import './style/css/components/search/box.css'
import './style/css/components/layout/header.css'
import './style/css/components/layout/footer.css'
import './style/css/components/profile/upload.css'
import './style/css/components/profile/input.css'
import './style/css/components/profile/textArea.css'
import './style/css/components/timer/timer.css'
import './style/css/components/button/button.css'
import './style/css/components/map/map.css'
import './style/css/components/share/share.css'
import './style/css/components/data/data.css'
import './style/css/components/shop/product.css'
import './style/css/components/comment/comment.css'
import './style/css/components/scrollbar.css'
import './style/css/components/loading.css'

//pages
import './style/css/pages/library.css'
import './style/css/pages/landing.css'
import './style/css/pages/callback.css'
import './style/css/pages/shop.css'
import './style/css/pages/detail-lawer.css'
import './style/css/pages/document.css'
import './style/css/pages/profile.css'
import './style/css/pages/profile-edit.css'
import './style/css/pages/auth.css'
import './style/css/pages/service.css'
import './style/css/pages/index.css'

// utitlites
import './style/css/utilites/color.css'
import './style/css/utilites/display.css'
import './style/css/utilites/flex.css'
import './style/css/utilites/height.css'
import './style/css/utilites/overflow.css'
import './style/css/utilites/position.css'
import './style/css/utilites/width.css'
import './style/css/utilites/margin.css'
import './style/css/utilites/padding.css'
import './style/css/utilites/font.css'

// import "react-notifications-component/dist/theme.css"
// import "leaflet/dist/leaflet.css";
// import "bootstrap/scss/bootstrap";

import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

